export enum FilesUploadStatusEnum {
	IDLE = 'idle',

	UPLOADING = 'uploading',
	UPLOAD_SUCCESS = 'uploadSuccess',
	UPLOAD_FAILURE = 'uploadFailure',
}

export enum CaseProcessingStatusEnum {
	IDLE = 'idle',

	UPDATING = 'updating',
	UPDATE_SUCCESS = 'updatingSuccess',
	UPDATE_FAILURE = 'updatingFailure',
}